import { Component, Input } from '@angular/core';
import { SewMarkdown, SewWsLink, SewWsParagraph, SewWsRichtext } from '@sew/ui-components-angular/standalone';
import { Labels } from '../../../../services/labels/label.types';

@Component({
    selector: 'reg-energy',
    templateUrl: './energy.component.html',
    styleUrls: ['./energy.component.scss'],
    imports: [SewMarkdown, SewWsLink, SewWsParagraph, SewWsRichtext],
})
export class EnergyComponent {
    @Input() public labels?: Labels;
}
